import Vue from 'vue';
import { forEach } from 'lodash';
var VueScrollTo = require('vue-scrollto');
var TweenMax = require("TweenMax");
var TimelineMax = require("TimelineMax");
var EasePack = require("EasePack");
var ScrollMagic = require('ScrollMagic');
export default Vue.extend({
    name: 'PageNav',
    props: ['visibleAt', 'sections'],
    directives: {
        'scroll-to': VueScrollTo
    },
    data() {
        return {
            currentScroll: null
        };
    },
    mounted() {
        // get returned Scene
        let pageNavScene = this.pageNavAnimation();
        // init Array
        let allScenes = [];
        allScenes = allScenes.concat(pageNavScene);
        // init controller
        var controller = new ScrollMagic.Controller();
        controller.addScene(allScenes);
        /* init active section watcher */
        var sections = document.querySelectorAll('.section');
        window.addEventListener('scroll', e => {
            forEach(sections, section => {
                var sectionTop = section.getBoundingClientRect().top;
                if (sectionTop < 800) {
                    this.currentScroll = section.id;
                }
            });
        });
    },
    methods: {
        onScrollClick(e) {
            this.pageNavBackgroundAnimation();
            var target = e.target;
            var activePageNav = document.querySelector('.page-nav a.active');
            if (activePageNav) {
                activePageNav.classList.remove('active');
            }
            target.classList.add('active');
        },
        pageNavAnimation() {
            /*************************** */
            /********** Greensock *********/
            /*************************** */
            // init timeline
            let pageNavTL = new TimelineMax();
            // page-navnav
            pageNavTL
                .fromTo('.component-page-nav', .5, {
                'autoAlpha': 0,
                'y': 10,
            }, {
                'autoAlpha': 1,
                'y': 0,
                clearProps: 'transform'
            })
                // stagger component-page-nav
                .staggerFromTo('.component-page-nav li', 1.5, {
                color: "#18a8c2",
                'x': 50,
                'autoAlpha': 0,
                'scale': 1.5,
            }, {
                color: "#ff7bc2",
                'x': 0,
                'autoAlpha': 1,
                'scale': 1,
                ease: EasePack.Power4.easeOut,
            }, 0.2)
                .fromTo('.component-page-nav .grey-background', 1, {
                'x': '-75',
            }, {
                'x': 0,
                ease: EasePack.Power4.easeOut,
            }, 0.4)
                .stop();
            /*************************** */
            /********** Scrollmagic *********/
            /*************************** */
            // create a scene
            const PageNavScene = new ScrollMagic.Scene({
                triggerElement: this.visibleAt,
                triggerHook: 0.25
            })
                .on("enter", () => {
                pageNavTL.play();
            });
            /* return scene */
            return [PageNavScene];
        },
        pageNavBackgroundAnimation() {
            /*************************** */
            /********** Greensock *********/
            /*************************** */
            // init timeline
            let pageNavBackgroundTL = new TimelineMax();
            // get grey-background DOM-Element
            let greyBackground = document.querySelector('.grey-background');
            // page-nav
            pageNavBackgroundTL
                .fromTo(greyBackground, .35, {
                'x': 0,
            }, {
                'x': '-75',
                ease: EasePack.Power4.ease
            })
                .fromTo(greyBackground, .5, {
                'x': '-75',
            }, {
                'x': 0,
                ease: EasePack.Power4.easeOut,
                delay: 0.2
            })
                .play();
        },
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/page-nav/PageNav.ts
// module id = null
// module chunks = 